import React from "react";
import { TableComponent } from "../table/TableComponent";
import { Space } from "../space/Space";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close-medium";
import { useFilterSheets } from "../../features/filter-sheets/hooks";
import { ISearchTableProps } from "./definitions";

export const SearchTable: React.FC<ISearchTableProps> = ({
    searchRequest,
    setIsSearchTableVisible,
}) => {
    const { resetFilters } = useFilterSheets();

    return (
        <>
            <Space size={"m"} />
            <Box type={"fill"} backgroundColor={"principal"} spacingInset={"400"}>
                <Row width={"100%"} widths={["grid-4", "fill", "fit"]}>
                    <Text type={"h300"}>Search Results</Text>
                    <div />
                    <Button
                        onClick={() => {
                            setIsSearchTableVisible(false);
                            resetFilters();
                        }}
                        type="icon"
                    >
                        <Icon tokens={closeMediumTokens} />
                    </Button>
                </Row>
                <Space size={"xxs"} />
                <TableComponent
                    tableUseCase={searchRequest.useCase}
                    tableQueryParams={searchRequest.queryParams}
                />
            </Box>
        </>
    );
};
